import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner1.jpg";
import news11Img from "../../images/news/news1_1.png";
import news12Img from "../../images/news/news1_2.png";
import news13Img from "../../images/news/news1_3.png";
import news14Img from "../../images/news/news1_4.png";
import news15Img from "../../images/news/news1_5.png";

import { withTranslation } from "react-i18next";

	
class News1 extends Component {
	componentDidMount() {
		
	}

	componentWillMount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("News1_Title");
	}

	componentWillUnmount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("Home_Title");
	}

	render() {
		const { t } = this.props;
		return (
			<>
				<Header />

				<div className="page-content">
					<div
						className="page-banner ovbl-dark"
						style={{ backgroundImage: "url(" + bannerImg + ")" }}
					>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">{t("News1_Title")}</h1>
							</div>
						</div>
					</div>
					<div className="breadcrumb-row">
						<div className="container">
							<ul className="list-inline">
								<li>
									<Link to="/">{t("News1_LinkHome")}</Link>
								</li>
								<li>{t("News1_LinkCourses")}</li>
							</ul>
						</div>
					</div>
					<div className="content-block">
						<div className="section-area section-sp1">
							<div className="container">
								<div className="row d-flex flex-row-reverse">
									<div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
										<div className="courses-post">
											<h1>{t("News1_Content_H")}</h1>
											<p>{t("News1_Content_P1")}</p>
											<p style={{ textAlign: "center" }}><img alt="" src={news11Img} width="50%" /></p>
											<p>{t("News1_Content_P2")}</p>
											<p style={{ textAlign: "center" }}><img alt="" src={news12Img} width="50%" /></p>
											<p>{t("News1_Content_P3")}</p>
											<p style={{ textAlign: "center" }}><img alt="" src={news13Img} width="50%" /></p>
											<p>{t("News1_Content_P4")}</p>
											<p style={{ textAlign: "center" }}><img alt="" src={news14Img} width="50%" /></p>
											<p>{t("News1_Content_P5")}</p>
											<p style={{ textAlign: "center" }}><img alt="" src={news15Img} width="50%" /></p>
											<p>{t("News1_Content_P6")}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default News1 = withTranslation()(News1);
